import React from 'react';
import { PaperDarkBG, PaperGradientBG } from "../kits/DesignKit";
import UnderlineSketch from './UnderlineSketch';

function SectionBlog() {
  return (
    <PaperGradientBG>
      <section className="py-16 sm:py-20 md:py-24">
        <div className="container mx-auto text-center px-6 max-w-4xl">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-mono text-amber-100 mb-6 leading-relaxed">
            Lern Studio{" "}
            <span className="text-brand">+</span>{" "}
            <span className="text-brand relative inline-block">
              Echte Lösungen
              <UnderlineSketch
                className="absolute -bottom-1 left-0 w-full h-2"
                color="zenBrand"
              />
            </span>
            <br />
            um mehr zu{" "}
            <span className="text-brand relative inline-block">
              wissen
              <UnderlineSketch
                className="absolute -bottom-1 left-0 w-full h-2"
                color="zenBrand"
              />
            </span>
          </h1>
          <p className="text-sm sm:text-base font-mono text-amber-100 italic mt-4">
            by Denis Bitter
          </p>
        </div>
      </section>
    </PaperGradientBG>
  );
}

export default SectionBlog;